import { jsx as _jsx } from "react/jsx-runtime";
import { createContext } from 'react';
/**
 * Default link component that renders a plain `<a>` element.
 *
 * Used when no `AetherProvider` is present in the tree (e.g. unit tests,
 * component visual tests, standalone usage). Discards `hardNav` since native anchors
 * always perform full page navigation.
 */
export const DefaultLinkComponent = ({ hardNav: _, ...props }) => (_jsx("a", { ...props }));
// eslint-disable-next-line react/only-export-components -- The provider and consumers share this module-scoped context.
export const LinkComponentContext = createContext(DefaultLinkComponent);
LinkComponentContext.displayName = 'AetherLinkComponentContext';
//# sourceMappingURL=LinkComponentContext.js.map